import { createCategoryLandingDefaultFormFields } from '../common/formFields'
import { getCategoryLandingHeroImage } from '../common/heroImages'
import { createInsuranceProductPreset } from '../common/productPresetFactory'

export function getProductFirePreset(presetKey = 'default') {
  if (presetKey === 'basic-template-4' || presetKey === 'basic-template-5') {
    const copyByPreset = {
      'basic-template-4': {
        heroTitle: '건물 유형과 배상 위험을 기준으로 화재보험을 점검합니다',
        heroSubtitle: '주거 공간과 사업장에 필요한 재산 손해, 배상책임, 사용 목적별 확인 항목을 정리합니다.',
        formTitle: '화재보험 점검 상담',
      },
      'basic-template-5': {
        heroTitle: '사업장과 주거공간 모두를 위한 화재 리스크 전략 안내',
        heroSubtitle: '재산 손해, 배상책임, 건물 유형별 포인트를 현재 상황에 맞춰 차분하게 안내해드립니다.',
        formTitle: '1:1 화재 상담',
      },
    }
    return createInsuranceProductPreset(
      'PRODUCT_FIRE',
      copyByPreset[presetKey],
      presetKey,
    )
  }
  if (presetKey === 'clean-form') {
    return {
      key: 'product-fire-clean-form',
      category: 'PRODUCT_FIRE',
      name: '화재보험 기본 템플릿 2 - 간편 문의형',
      heroTitle: '건물 유형과 사용 목적에 맞는 화재보험 기준을 확인하세요',
      heroSubtitle: '화재 손해와 배상 위험을 건물 상황에 맞춰 점검합니다.',
      heroImageFileId: getCategoryLandingHeroImage('PRODUCT_FIRE'),
      formTitle: '화재보험 상담 신청',
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '🏠', title: '건물 유형 확인', description: '주택, 상가, 임대 건물에 따라 기준이 달라집니다.' },
            { icon: '🔥', title: '재산 손해 대비', description: '화재로 인한 직접 손해 범위를 확인합니다.' },
            { icon: '🛡️', title: '배상책임 점검', description: '이웃 피해와 일상 배상 위험까지 함께 봅니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields(),
      surveyCustomFields: [],
      customConfig: {
        templateStyle: 'clean-form',
        heroBackgroundColor: '#ffebec',
        heroTextColor: '#1e293b',
        heroSubtitleColor: '#dc2626',
        formBorderColor: '#ff7b1b',
        formBorderWidth: 4,
      },
    }
  }

  if (presetKey === 'hanwha-sections') {
    return {
      key: 'product-fire-hanwha-sections',
      category: 'PRODUCT_FIRE',
      name: '화재보험 기본 템플릿 3 - 설명형',
      heroTitle: '건물 유형별 화재보험 확인 항목을 정리합니다',
      heroSubtitle: '건물 용도, 소유·임대 여부, 배상 위험을 기준으로 상담 흐름을 안내합니다.',
      heroImageFileId: getCategoryLandingHeroImage('PRODUCT_FIRE'),
      formTitle: '맞춤 화재보험 신청',
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '🏠', title: '건물 유형별 확인', description: '주택, 상가, 오피스텔 등 상황별로 확인합니다.' },
            { icon: '🔥', title: '화재 손해 범위', description: '재산 피해와 복구 비용 관련 항목을 봅니다.' },
            { icon: '📞', title: '배상 위험 상담', description: '이웃 피해와 책임 범위까지 상담합니다.' },
          ],
        },
        {
          type: 'image',
          title: '화재보험, 이런 분께 필요합니다',
          caption: '건물 유형과 사용 목적에 따라 확인해야 하는 보장 포인트를 안내합니다.',
        },
        {
          type: 'benefit-cards',
          title: '핵심 안내 포인트',
          items: [
            { icon: '✅', title: '건물/가재도구 보장', description: '상황에 맞는 보장 항목을 정리해드립니다.' },
            { icon: '✅', title: '배상책임 체크', description: '이웃 피해까지 고려한 구성이 가능합니다.' },
            { icon: '✅', title: '상황별 비교 안내', description: '건물 상황에 맞는 보장 방향을 설명합니다.' },
          ],
        },
        {
          type: 'process-steps',
          title: '상담 진행 방식',
          steps: [
            { number: 1, icon: '📝', title: '상담 신청', description: '기본 정보를 남겨 주세요.' },
            { number: 2, icon: '🔎', title: '조건 확인', description: '건물 유형과 보장 니즈를 파악합니다.' },
            { number: 3, icon: '💬', title: '맞춤 제안', description: '필요한 보장을 중심으로 안내해드립니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: [],
      customConfig: {
        templateStyle: 'hanwha-sections',
        heroBackgroundColor: '#dff6f1',
        heroTextColor: '#111827',
        heroSubtitleColor: '#0f766e',
        formBorderColor: '#ff7b1b',
        formBorderWidth: 3,
        highlightsBackgroundColor: '#f8fafc',
        recommendedTitle: '추천상품',
      },
    }
  }

  if (presetKey === 'lead-gen-fullbleed') {
    return createInsuranceProductPreset(
      'PRODUCT_FIRE',
      {
        heroTitle: '건물 유형별 화재보험 확인 항목을 정리합니다',
        heroSubtitle: '건물 용도와 배상 위험을 기준으로 상담 흐름을 안내합니다.',
        formTitle: '화재보험 상담 신청',
      },
      'lead-gen-fullbleed',
    )
  }

  return {
    key: 'product-fire-default',
    category: 'PRODUCT_FIRE',
    name: '화재보험 기본 템플릿 1 - 일반형',
    heroTitle: '건물 유형과 배상 위험을 기준으로 화재보험을 점검합니다',
    heroSubtitle: '화재, 배상, 재산 손해까지 건물 상황에 맞는 보장 포인트를 설명합니다.',
    heroImageFileId: getCategoryLandingHeroImage('PRODUCT_FIRE'),
    formTitle: '화재보험 상담 신청',
    contentSections: [
      {
        type: 'icon-grid',
        title: '',
        columns: 3,
        items: [
          { icon: '🏠', title: '건물 유형별 안내', description: '상황에 맞는 보장 포인트를 정리합니다.' },
          { icon: '🔥', title: '핵심 화재 보장', description: '재산 손해와 화재 피해를 함께 설명합니다.' },
          { icon: '🛡️', title: '배상 위험 대비', description: '이웃 피해와 책임 범위까지 확인합니다.' },
        ],
      },
      {
        type: 'text',
        title: '화재보험, 이런 분께 필요합니다',
        content: '주택, 상가, 오피스텔, 임대 건물 등 건물 용도와 상황에 따라 꼭 확인해야 할 보장 포인트를 안내합니다.',
      },
    ],
    formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
    surveyCustomFields: [],
    customConfig: {
      templateStyle: 'default',
      heroBackgroundColor: '#f8fafc',
      heroTextColor: '#0f172a',
      heroSubtitleColor: '#475569',
    },
  }
}
